export const TextView = ({ label, value }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
        {label}
      </h1>
      <div className="my-1">{value ?? "--"}</div>
    </div>
  );
};

export const TextViewArray = ({ label, value = [] }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
        {label}
      </h1>
      <div className="my-1">
        {value?.map((ele, index) => {
          return (
            <span key={index}>
              <span className="text-greyText">{index ? " | " : ""}</span>
              {ele ? ele : "--"}
            </span>
          );
        })}
      </div>
    </div>
  );
};
export const EditorTextView = ({ label, value }) => {
  return (
    <div className="my-4">
      <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
        {label}
      </h1>

      <div
        className="my-1 prose max-w-none"
        dangerouslySetInnerHTML={{ __html: value || "--" }}
      />
    </div>
  );
};
